import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconRocket.c.svg?react';

export const IconRocket = withIconWrapper(ReactComponent);
